import {first} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {ResourceService} from '../../../resource/resource.service';
import {DatePipe} from '@angular/common';
import {FilterResult} from '../../../resource/filterresult';
import {EnvironmentConfigService} from '../../../core/services/environment-config.service';

@Component({
  selector: 'datatable-multivalue-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-dialog>
      <app-dialog-title>{{ attributeName }}</app-dialog-title>
      <app-dialog-subtitle>{{ displayName }}</app-dialog-subtitle>
      <div mat-dialog-content>
        <ul>
          @for (item of rightModel; track item) {
            <div>
              @switch (dataType) {
                @case ('Reference') {
                  <li>
                    <div class="row">
                      <div class="col-md-3">
                        <a
                          (click)="
                            openDetail(
                              item ? item[envConfig.getAttributeName('ObjectID')] : null,
                              $event
                            )
                          "
                          >{{ item ? item[envConfig.getAttributeName('DisplayName')] : '' }}</a
                        >
                      </div>
                      <div class="col-md-9">
                        {{ item ? item[envConfig.getAttributeName('Description')] : '' }}
                      </div>
                    </div>
                  </li>
                }
                @case ('DateTime') {
                  <li>{{ item | localDate | async }}</li>
                }
                @default {
                  <li>{{ item }}</li>
                }
              }
            </div>
          }
        </ul>
      </div>
    </app-dialog>
  `,
  styleUrls: ['./datatable-multivalue-dialog.component.scss'],
  standalone: false,
})
export class DatatableMultivalueDialogComponent {
  public attributeName: string;
  public displayName: string;
  public dataType: string;
  public model: any[];
  public openDetailEmitter: EventEmitter<{objectID: string; event: MouseEvent}> =
    new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<DatatableMultivalueDialogComponent>,
    private changeDetector: ChangeDetectorRef,
    private datePipe: DatePipe,
    public envConfig: EnvironmentConfigService,
  ) {}

  public set observable(obs: Observable<FilterResult>) {
    obs.pipe(first()).subscribe(
      (fr: FilterResult) => {
        this.model = fr.Results;
        this.changeDetector.markForCheck();
      },
      () => {
        console.error('Cannot display multi-value view dialog');
        this.dialogRef.close();
      },
    );
  }

  openDetail(ObjectID: string, event: MouseEvent) {
    this.openDetailEmitter.emit({objectID: ObjectID, event: event});
    this.dialogRef.close();
  }

  get leftModel(): any[] {
    if (this.model == null) return [];
    return this.model.slice(0, Math.ceil(this.model.length / 2));
  }

  get rightModel(): any[] {
    if (this.model == null) return [];
    return this.model;
  }
}
